import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

function MobileTableBody({
  item,
  activeworkfromhome
}) {
  const formatDate = date => moment(date).format("DD-MM-YY")
  const renderTableRow = (label, value) => (
    <tr>
      <th scope="row" className="text-uppercase">
        {label}
      </th>
      <td>{value}</td>
    </tr>
  )
  return (
    <>
      {activeworkfromhome?.id === 1 ? <>
        {renderTableRow("Employee Name", item.employeeName)}
        {renderTableRow("Date", formatDate(item.date))}
        {renderTableRow("Start Time", item.starttime)}
        {renderTableRow("End Time", item.endtime)}
        {renderTableRow("Total Hours", item.totalHours)}
        {renderTableRow("WFH", item.hoursWorkedFromHome)}
      </> : <>
        {renderTableRow("Employee Name", item.employeeName)}
        {renderTableRow("No of days", item.numberOFDays)}
      </>}

    </>
  )
}

MobileTableBody.propTypes = {
  item: PropTypes.object.isRequired,
  supervisorFilter: PropTypes.object.isRequired,
  activeReportStatus: PropTypes.object.isRequired,
  hidecolumn: PropTypes.bool.isRequired,
  handleOnExpand: PropTypes.func.isRequired,
  handleVerify: PropTypes.func.isRequired,
}

export default MobileTableBody
